// =============== plugin import ============= //
import {useState, useEffect, useRef} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import axios from 'axios'
// ============= component import ============= //
import AddService from './component/AddService';
import ServiceList from './component/ServiceList';
import SideDrawer from '../../../../../../../../component/common/SideDrawer';
import UpdateServiceDrawer from './component/UpdateServiceDrawer';

const ServiceSetup = (props) => {
    const api_base_url = process.env.REACT_APP_API_URL;
    const loginUserType = localStorage.getItem('type');
    const {formData, formValidateError} = props;

    // -------- define all state here -------- //
    const [ serviceFormUpdateId , setServiceFormUpdateId] = useState(-1);
    const [ totalServiceList , setTotalServiceList] = useState([]);
    const [ serviceDrawerIsOpen, setServiceDrawerIsOpen] = useState(false);
    const [ updateServiceList , setUpdateServiceList ] = useState([]);
    const [serviceStateIsChange, setServiceStateIsChange] = useState(false)
    const serviceFormSaveHandler = async (serviceData) => {
        setServiceStateIsChange(true)

        // ----- check duplicate service name ----- //
        let serviceDuplicateData = false;
        if(formData['step4'].service_setup.service_name !== ''){
            serviceDuplicateData = formData['step4'].service_setup.some(
                (services) => services.service_name.trim() === serviceData.service_name.trim()
            );
        }

        // ------- check duplicate action name -------- //
        let isDupProductFeatureAssociationData = false
        let serviceSetupAction = false
        let informationAction = false

        const productFeatureAssData = formData['step3'].product_features_association_data
        if(productFeatureAssData.length > 0){
            isDupProductFeatureAssociationData = productFeatureAssData.some(
                (data) => data.action_name.trim() === serviceData.action_name.trim()
            );
        }

        const checkServiceData = formData['step4'].service_setup
        if(checkServiceData.length > 0){
            serviceSetupAction = checkServiceData.some(
                (data) => data.action_name.trim() === serviceData.action_name.trim()
            );
        }

        const informationData = formData['step2'].others_form_setup
        if(informationData.length > 0){
            informationAction = informationData.some(
                (data) => data.action_name.trim() === serviceData.action_name.trim()
            );
        }
        
        if(serviceFormUpdateId < 0){
            // ---- insert ---- //
            if (serviceDuplicateData) {
                await Swal.fire({
                    text: 'Duplicate service name cannot be added !',
                    icon: 'error',
                    showCancelButton: true,
                    showConfirmButton : false,
                    cancelButtonText: 'OK',
                });
                return;
            }

            if(isDupProductFeatureAssociationData || serviceSetupAction || informationAction){
                await Swal.fire({
                    text: 'Duplicate action cannot be added !',
                    icon: 'error',
                    showCancelButton: true,
                    showConfirmButton : false,
                    cancelButtonText: 'OK',
                });
                return;
            }

            if(serviceData.service_synonyms !== ''){
                serviceData.service_synonyms = JSON.parse(serviceData.service_synonyms)
            }
            else{
                serviceData.service_synonyms = []
            }

            setTotalServiceList((prevList) => [...prevList, serviceData]);
            props.onInputChange(
                'step4',
                'service_setup',
                [
                    ...(Array.isArray(formData['step4'].service_setup) ? formData['step4'].service_setup : []),
                    serviceData
                ]
            );
        }
        else{
            // ----- update ----- //
            const updateServiceState = [...formData['step4'].service_setup];
            if(updateServiceState[serviceFormUpdateId].service_name !== serviceData.service_name){
                if (serviceDuplicateData) {
                    await Swal.fire({
                        text: 'Duplicate service name cannot be added !',
                        icon: 'error',
                        showCancelButton: true,
                        showConfirmButton : false,
                        cancelButtonText: 'OK',
                    });
                    return;
                }
            }
            if(updateServiceState[serviceFormUpdateId].action_name !== serviceData.action_name){
                if(isDupProductFeatureAssociationData || serviceSetupAction || informationAction){
                    await Swal.fire({
                        text: 'Duplicate action cannot be added !',
                        icon: 'error',
                        showCancelButton: true,
                        showConfirmButton : false,
                        cancelButtonText: 'OK',
                    });
                    return;
                }
            }
            if(serviceData.service_synonyms !== ''){
                serviceData.service_synonyms = JSON.parse(serviceData.service_synonyms)
            }
            else{
                serviceData.service_synonyms = []
            }
            let old_service_name = updateServiceState[serviceFormUpdateId].service_name;
            let new_service_name = serviceData.service_name;

            // ------ update service_attributes_association ------- //
            const saAssociation = formData['step4'].service_attributes_association
            if(Object.keys(saAssociation).length > 0){
                if (saAssociation[old_service_name]) {
                    props.productFeatureAssociationApiCall(true)
                    const updatedState = {
                        ...saAssociation,
                        [new_service_name]: saAssociation[old_service_name]
                    };
                    delete updatedState[old_service_name];
                    props.onInputChange('step4', 'service_attributes_association', updatedState);

                }
            }

            // ------- update service_attributes_association_setup -------- //
            const saAssociationSetup = formData['step4'].service_attributes_association_setup;
            if( saAssociationSetup.length > 0 ){
                props.serviceAttributeAssSetupApiCall(true)
                var needArr = saAssociationSetup.map((item) => {
                    return {
                        ...item,
                        service_attribute_association: item.service_attribute_association.map((assoc) => {
                            return {
                                label: assoc.label.includes(`Service: ${old_service_name}`)
                                    ? assoc.label.replace(`Service: ${old_service_name}`, `Service: ${new_service_name}`)
                                    : assoc.label,
                                value: assoc.value.includes(`Service: ${old_service_name}`)
                                    ? assoc.value.replace(`Service: ${old_service_name}`, `Service: ${new_service_name}`)
                                    : assoc.value,
                            };
                        }),
                    };
                });
                props.onInputChange(
                    'step4',
                    'service_attributes_association_setup',
                    needArr
                );
            }


            // -------- update service_setup --------- //
            updateServiceState[serviceFormUpdateId] = serviceData;
            setTotalServiceList(updateServiceState);
            props.onInputChange(
                'step4',
                'service_setup',
                updateServiceState
            );
            setServiceDrawerIsOpen(false)
        }
        setServiceFormUpdateId(-1)
    }

    const serviceUpdateOnClickHandler = (index) => {
        setUpdateServiceList([totalServiceList[index]])
        setServiceFormUpdateId(index)
        setServiceDrawerIsOpen(true)
    }

    const serviceDeleteOnClickHandler = (index) => {
        setServiceStateIsChange(true)
        const updateServiceList = [...totalServiceList];
       
        const deleteServiceName = updateServiceList[index].service_name;
        // ------ delete service_attributes_association ------- //
        const saAssociation = formData['step4'].service_attributes_association
        if(Object.keys(saAssociation).length > 0 
            && saAssociation.hasOwnProperty(deleteServiceName)
        )
        {
            props.productFeatureAssociationApiCall(true)
            const newObj = Object.keys(saAssociation)
            .filter(key => key !== deleteServiceName)
            .reduce((acc, key) => {
                acc[key] = saAssociation[key];
                return acc;
            }, {});
            props.onInputChange('step4', 'service_attributes_association', newObj);
        }

        // ------ delete service_attributes_association_setup ----- //
        const saAssociationSetup = formData['step4'].service_attributes_association_setup;
        if( saAssociationSetup.length > 0 ){
            props.serviceAttributeAssSetupApiCall(true)
            const filterServiceData = (data, serviceToRemove) => {
                return data
                .map((item) => ({
                    ...item,
                    service_attribute_association: item.service_attribute_association.filter(
                        (assoc) => !assoc.value.includes(`Service: ${serviceToRemove}`)
                    ),
                }))
                .filter((item) => item.service_attribute_association.length > 0);
            };
            const saAssDataUpdate =  filterServiceData(saAssociationSetup, deleteServiceName);
            props.onInputChange(
                'step4',
                'service_attributes_association_setup',
                saAssDataUpdate
            );
        }
        
        // ------ delete service_setup --------- //
        updateServiceList.splice(index, 1);
        setTotalServiceList(updateServiceList);
        props.onInputChange(
            'step4',
            'service_setup',
            updateServiceList
        );
    }

    const serviceListOnDropHandler = (rearrangeServiceData) => {
        setServiceStateIsChange(true)
        setTotalServiceList(rearrangeServiceData);
        props.onInputChange(
            'step4',
            'service_setup',
            rearrangeServiceData
        );
    }

    const drawerOnCloseHandler = (drawerName) => {
        const drawerMap = {
            service_update_drawer: () => {
                setServiceDrawerIsOpen(false);
                setServiceFormUpdateId(-1);
            },
        };
        if (drawerMap[drawerName]) {
            drawerMap[drawerName]();
        }
    }

    useEffect(() => {
        setServiceStateIsChange(false)
        setTotalServiceList(formData['step4'].service_setup);
    },[formData['step4']])

    // ------ service setup api call ------ //
    const serviceSetupFrmRef = useRef();
    useEffect(() => {
        const saveServiceDetails = async () => {
            if(!serviceStateIsChange) return
            const saveServiceData = async () => {
                let service = [];
                if (totalServiceList.length > 0) {
                    const indexService = totalServiceList.map((service, index) => ({
                        ...service,
                        index,
                    }));
                    service = indexService
                }
                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token')
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken')
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }
                let serviceFormData = new FormData();
                serviceFormData.append("action_type", 'service_setup');
                serviceFormData.append("bot_id", formData.bot_id);
                serviceFormData.append("step", "step4");
                serviceFormData.append("data", JSON.stringify(service));
                serviceFormData.append("sass_id", localStorage.getItem('sass_id'));
                serviceFormData.append("user_type", localStorage.getItem('type'));
                serviceFormData.append("user_name", loginUserType == 'SA' ? localStorage.getItem('system_username') : '');
                const apiHeaders = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "x-access-token": apiToken,
                    },
                };
                try {
                    await axios.post(`${api_base_url}api/save-bot-details`, serviceFormData, apiHeaders)
                    .then(async (res) => {
                        if(res.data.status === 'success'){
                            serviceFormData = new FormData();
                            setServiceStateIsChange(true)
                            serviceSetupFrmRef.current?.resetForm();
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                } catch (error) {
                    console.error("Error during save:", error);
                }
            }
            await saveServiceData();
        }
        saveServiceDetails();
    },[totalServiceList])
    

    return (
        <>
            <div className="row mb-5 border border-dashed border-gray-400 rounded p-5">
                <div className='col-md-6'>
                    <a className="fw-bold text-gray-800 mb-2 fs-3">
                        Service Setup
                    </a>
                </div>
                <div className='col-md-6 text-end'>
                    <>
                        <span 
                            className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                            onClick={(e) => props.infoOpenOnCLick('service_setup')}
                        >
                            <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                        </span>
                    </>
                </div>
                
                <div className="col-md-12">
                    <AddService
                        formData={formData}
                        formValidateError = {formValidateError}
                        serviceFormSave={serviceFormSaveHandler}
                        updateServiceList={updateServiceList}
                        isInfoOpenHandler={props.isInfoOpenHandler}
                        ref={serviceSetupFrmRef}
                    />
                </div>
                <div className='col-md-12'>
                    <ServiceList
                        totalServiceList={totalServiceList}
                        serviceUpdateOnClick={serviceUpdateOnClickHandler}
                        serviceDeleteOnClick={serviceDeleteOnClickHandler}
                        serviceListOnDrop={serviceListOnDropHandler}
                    />
                </div>
            </div>

            <SideDrawer
                title={'Service Data Update'}
                width={600}
                open={serviceDrawerIsOpen}
                drawer_name={'service_update_drawer'}
                placement={'right'}
                closable={false}
                drawerOnClose={drawerOnCloseHandler}
            >
                <UpdateServiceDrawer
                    formData={formData}
                    formValidateError = {formValidateError}
                    serviceFormSave={serviceFormSaveHandler}
                    updateServiceList={updateServiceList}
                    ref={serviceSetupFrmRef}
                />
            </SideDrawer>
        </>
    )
}

export default ServiceSetup
